import PlatformError from "../PlatformError";

export default new PlatformError(
  "ERROR",
  "Your browser window width was determined to be too low for this study",
  "Screenout",
  "User failed viewport width check",
  "app.start.viewportwidth"
);
